export const SLUG_API_URL = `${process.env.REACT_APP_PUBLIC_API_URL}/validate`;
export const CARDINAL_URL = `${process.env.REACT_APP_PUBLIC_CARDINAL_URL}`;
export const BASE_API_URL = `${process.env.REACT_APP_PUBLIC_API_URL}`;
export const BASE_PUBLIC_API_URL = `${process.env.REACT_APP_PUBLIC_IFRAME_API_URL}`;